// src/pages/Home.js
import React from 'react';
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import { useNavigate, Link } from "react-router-dom";
import { useUser } from "../context/UserContext";
import Logo from './../images/logo.svg'
const Home = () => {
  const navigate = useNavigate();
  const { user, loginUser } = useUser(); // Use context
  const GoToLogin = () => {
    navigate("/login");

  };
  const GoToPremium = () => {
    navigate("/app/premium");

  };
  return (
    <div className="min-h-screen">
      {/* Navigation */}
      <nav className="flex justify-between items-center px-6 py-4">
        <img src={Logo} alt="HeroFit" className="h-10" />
        {user ? (
          <img
            src={user.avatar} // Đảm bảo rằng user có thuộc tính profilePicture
            alt="User Avatar"
            className="h-8 w-8 rounded-full cursor-pointer"
            onClick={() => {
              navigate("/app");
            }}
          />
        ) : (
          <button onClick={GoToLogin}>
            <span className="text-gray hover:text-gray-900">LOGIN</span>
          </button>
        )}
      </nav>

      {/* Hero Section */}
      <section className="max-w-6xl mx-auto px-4 py-16 text-center">
        <h1 className="text-5xl font-bold text-gray-900 mb-4">
          Gamify your fitness
        </h1>
        <p className="text-xl text-gray-600 mb-8">
          Track your workouts to level up your avatar and climb leaderboards
        </p>
        <div className="flex justify-center gap-4">
          <button className="bg-black text-white px-6 py-2 rounded-lg flex items-center gap-2">
            <FaApple className="text-xl" />
            App Store
          </button>
          <button className="bg-black text-white px-6 py-2 rounded-lg flex items-center gap-2">
            <FaGooglePlay className="text-xl" />
            Google Play
          </button>
        </div>
      </section>

      {/* Social Proof */}
      <section className="max-w-md mx-auto px-4 py-8">
        <div className="bg-white rounded-xl shadow-lg p-6">
          <div className="flex items-start gap-4">
            <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/screencapture-theherofit-app-2025-02-10-09_01_40-fLrXZkldBlHIRV8kC6nWL4d9vtQbB9.png"
              alt="User Avatar"
              className="w-12 h-12 rounded-full"
            />
            <div>
              <h3 className="font-semibold">Samuel Davis</h3>
              <p className="text-gray-600">
                Used it to gamify their approach to getting and staying fit
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Pain Points */}
      <section className="max-w-6xl mx-auto px-4 py-16">
        <h2 className="text-3xl font-bold text-center mb-12">
          Exercising consistently is hard
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white rounded-xl p-6 shadow-sm">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
              🎯
            </div>
            <h3 className="font-semibold mb-2">Set a goal</h3>
            <p className="text-gray-600">I want to go gym 3x a week</p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm">
            <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mb-4">
              🏃
            </div>
            <h3 className="font-semibold mb-2">Try your best</h3>
            <p className="text-gray-600">Get gym membership</p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm">
            <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mb-4">
              😔
            </div>
            <h3 className="font-semibold mb-2">But life doesn't change...</h3>
            <p className="text-gray-600">I forgot my new habit</p>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="max-w-6xl mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 gap-16 items-center mb-32">
          <div className="bg-gray-100 rounded-xl p-4">
            <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/screencapture-theherofit-app-2025-02-10-09_01_40-fLrXZkldBlHIRV8kC6nWL4d9vtQbB9.png"
              alt="Workout Video"
              className="w-full rounded-lg"
            />
          </div>
          <div>
            <span className="text-orange-500 font-semibold">GAMIFICATION</span>
            <h2 className="text-3xl font-bold mt-2 mb-4">Make workouts fun</h2>
            <p className="text-gray-600">
              Create your workout avatar - challenge 10 characters to unlock new abilities and level up your fitness journey
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-16 items-center mb-32">
          <div>
            <span className="text-orange-500 font-semibold">GOALS</span>
            <h2 className="text-3xl font-bold mt-2 mb-4">Never miss your goal</h2>
            <p className="text-gray-600">
              If you don't stick to your goal, your avatar will HP will deplete...
              Don't worry, track to get your workout streak!
            </p>
          </div>
          <div className="space-y-4">
            <div className="bg-white p-4 rounded-lg shadow-sm">
              <div className="flex items-center gap-4 mb-2">
                <span>🚴‍♂️</span>
                <div className="flex-1 h-2 bg-orange-100 rounded-full">
                  <div className="w-3/4 h-full bg-orange-500 rounded-full"></div>
                </div>
              </div>
            </div>
            {/* Add more progress bars */}
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div className="bg-white rounded-xl shadow-sm p-6">
            <h3 className="font-semibold mb-4">League Week 3</h3>
            <div className="space-y-4">
              {/* Leaderboard entries */}
              <div className="flex items-center gap-4">
                <span>1</span>
                <img src="/avatar.png" alt="" className="w-8 h-8 rounded-full" />
                <span className="flex-1">Alex Wu</span>
                <span>50</span>
              </div>
              {/* Add more entries */}
            </div>
          </div>
          <div>
            <span className="text-orange-500 font-semibold">SOCIAL ACCOUNTABILITY</span>
            <h2 className="text-3xl font-bold mt-2 mb-4">Climb leaderboards</h2>
            <p className="text-gray-600">
              The more XP you earn, the higher you climb on your league's leaderboard
            </p>
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section className="max-w-6xl mx-auto px-4 py-16">
        <h2 className="text-3xl font-bold text-center mb-12">
          Level up workout avatars!
        </h2>
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto ">
          <div className="border rounded-xl p-6 bg-white">
            <h3 className="text-xl font-semibold mb-4">Discover</h3>
            <p className="text-gray-600 mb-4">Get a feel and see how it works for you</p>
            <div className="text-3xl font-bold mb-8">Free</div>
            <button className="w-full py-2 px-4 border border-gray-300 rounded-lg mb-8" onClick={GoToLogin}>
              GET STARTED
            </button>
            <ul className="space-y-4">
              <li className="flex items-center gap-2">
                <span>✓</span>
                Track basic avatar
              </li>
              <li className="flex items-center gap-2">
                <span>✓</span>
                Compete on leaderboard
              </li>
            </ul>
          </div>
          <div className="border-2 border-orange-500 rounded-xl p-6 bg-white">
            <h3 className="text-xl font-semibold mb-4">Premium</h3>
            <p className="text-gray-600 mb-4">Unlock all features</p>
            <div className="text-3xl font-bold mb-8">$19<span className="text-base font-normal">/mo</span></div>
            <button className="w-full py-2 px-4 bg-orange-500 text-white rounded-lg mb-8" onClick={GoToPremium}>
              GET PREMIUM
            </button>
            <ul className="space-y-4">
              <li className="flex items-center gap-2">
                <span>✓</span>
                Everything in free plan
              </li>
              <li className="flex items-center gap-2">
                <span>✓</span>
                Unlimited workout avatar
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-2xl mx-auto px-4 py-16 text-center">
        <h2 className="text-3xl font-bold mb-4">You're a hero!</h2>
        <p className="text-gray-600 mb-8">Sign up for free and grow your avatar!</p>
        <button className="bg-orange-500 text-white px-8 py-3 rounded-lg" onClick={GoToLogin}>
          GET STARTED NOW
        </button>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="max-w-6xl mx-auto px-4 grid md:grid-cols-2 gap-8">
          <div>
            <img src="/logo-white.svg" alt="HeroFit" className="h-8 mb-4" />
            <p className="text-gray-400">
              Track your workouts to level up your avatar and climb leaderboards
            </p>
          </div>
          <div className="grid grid-cols-2 gap-8">
            <div>
              <h4 className="font-semibold mb-4">Boring</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to={'term-of-service'} target='_blank'>Terms of Service</Link></li>
                <li><Link to={'privacy-policy'} target='_blank'>Privacy Policy</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">DOWNLOAD</h4>
              <div className="flex flex-col gap-4">
                <button className="bg-white text-black px-6 py-2 rounded-lg flex items-center gap-2">
                  <FaApple className="text-xl" />
                  App Store
                </button>
                <button className="bg-white text-black px-6 py-2 rounded-lg flex items-center gap-2">
                  <FaGooglePlay className="text-xl" />
                  Google Play
                </button>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;